import React, { useState } from 'react';
import BottomNavigation from 'src/common/refactoredComponents/bottomNavigation/BottomNavigation';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';

import { useDispatch, useSelector } from 'react-redux';
import {
    getRefinedOrderListData,
    getTerritory,
    getAccounts,
    setOrdersListFilter,
    setAppliedFilter,
    actionApplyFilterType,
    refineFilterAndOrderList,
    setShowExpandedView,
    setShowExpandedFilter,
    resetOrderListFilter,
    getDeniedOrderFilter,
    setNotificationFailure,
    SET_NOTIFICATION_FAILURE_RESPONSE,
} from 'src/pages/orders/redux/actions';
import CommonFilter from 'src/common/refactoredComponents/filter/CommonFilter';
import FilterView from 'src/common/refactoredComponents/filter/FilterView';
import {
    openFilterPopover,
    awaitingToggle,
    awaitingToggleMobile,
} from 'src/pages/orders/redux/actions';
import {
    ORDER_LIST_FILTER_DROPDOWN,
    ORDER_LIST_VIEW_FILTER_DROPDOWN,
} from 'src/constants/filterConstants.js';
import {
    FilterWrapperMain,
    FilterContentMain,
    FilterHeading,
    Reset,
    TextBold,
    FilterHeader,
    FilterBlock,
    EmptyBox,
    FilterHeaderContainer,
} from './OrderListFilters.styled';

import { ConstantOrderTypeFilter } from 'src/constants/orderListConstants.js';
import { convertDateToISOString, resumeScrolling, logErrorToConsole } from 'src/utils/util';
import { useTranslation } from 'react-i18next';
import { VISIBLE } from 'src/constants/appConstants';
import { useViewportHeight } from 'src/utils/useViewportHeight';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const OrderListFilters = (props) => {
    const dispatch = useDispatch();
    /* Fixed Set State */
    const { isLanguageChanged ,notificationFailureFilterVisibility} = useSelector((state) => ({
        isLanguageChanged: state.loginReducer.isLanguageChanged,
        notificationFailureFilterVisibility:state.loginReducer?.notificationFailureFilterVisibility,
    }));
    const [hideFilter, setHideFilter] = useState(false);
    const [showOrderStatus, setShowOrderStatus] = useState(false);
    const [showOrderType, setShowOrderType] = useState(false);
    const [orderListStatus, setOrderListStatus] = useState([]);
   
    const [orderTypeList, setOrderTypeList] = useState([]);
    const [apply, setApply] = useState(false);
    const [resetView, setResetView] = useState(false);
    const [resetFilter, setResetFilter] = useState(false);
    const [isViewChange, setIsViewChange] = useState(false);
    const { t } = useTranslation();

    const [showLocalExpandedFilter, setLocalExpandedFilter] = useState(null);
    const [showLocalExpandView, setLocalExpandView] = useState(null);
    const {
        appliedQuickFilter,
        appliedCategory,
        categoryFilters,
        accountSuccess,
        territorySuccess,
        districtSuccess,
        showExpandedView,
        showExpandedFilter,
        notificationFailureList,
        notificationStatus
    } = useSelector((state) => state.orderFilterReducer);
    const isDeniedOverrideClicked = useSelector(
        (state) => state.ordersListReducer.isDeniedOverrideClicked
    );
    const deniedOverrideToggle = useSelector(
        (state) => state.ordersListReducer.deniedOverrideToggle
    );

    const [selectedViews, setSelectedViews] = useState({
        districtView: {
            id: 'All District',
            name: t('orders.orderDetails.shipAndTrack.all'),
        },
        territoryView: {
            id: 'All Territory',
            name: t('orders.orderDetails.shipAndTrack.all'),
        },
        accountView: {
            id: 'All Account',
            name: t('orders.orderDetails.shipAndTrack.all'),
        },
        orderConditionView: {
            id: 'Assigned',
            name: t('calendar.filterResultsPanel.assigned'),
        },
    });

    const [defaultViews] = useState({
        districtView: {
            id: 'All District',
            name: t('orders.orderDetails.shipAndTrack.all'),
        },
        territoryView: {
            id: 'All Territory',
            name: t('orders.orderDetails.shipAndTrack.all'),
        },
        accountView: {
            id: 'All Account',
            name: t('orders.orderDetails.shipAndTrack.all'),
        },
        orderConditionView: {
            id: 'Assigned',
            name: t('calendar.filterResultsPanel.assigned'),
        },
    });

    const initDistrict = [
        { id: 'All District', name: t('orders.orderDetails.shipAndTrack.all') },
    ];

    const districtValue = useSelector(
        (state) => state.orderFilterReducer?.districts
    );

    let districtLists = districtSuccess
        ? districtValue?.length > 0
            ? [...initDistrict, ...districtValue]
            : initDistrict
        : [];

    let territoryValue = useSelector(
        (state) => state.orderFilterReducer?.territories
    );

    let orderConditionLists = [
        { id: 'Assigned', name: t('calendar.filterResultsPanel.assigned') },
        { id: 'Unassigned', name: t('calendar.filterResultsPanel.unassigned') },
    ];

    const initTerritory = [
        {
            id: 'All Territory',
            name: t('orders.orderDetails.shipAndTrack.all'),
        },
    ];

    let territoriesLists = territorySuccess
        ? territoryValue?.length > 0
            ? [...initTerritory, ...territoryValue]
            : initTerritory
        : [];

    const initAccount = [
        { id: 'All Account', name: t('orders.orderDetails.shipAndTrack.all') },
    ];

    let accountValue = useSelector(
        (state) => state.orderFilterReducer?.accounts
    );

    let accountLists = accountSuccess
        ? accountValue?.length > 0
            ? [...initAccount, ...accountValue]
            : initAccount
        : [];

    const { filter } = useSelector((state) => state.appliedOrdersFilterReducer);

    const { appliedView, appliedFilter } = useSelector(
        (state) => state.orderFilterReducer
    );

    const {
        appliedDistrict,
        appliedTerritory,
        appliedAccount,
        appliedOrderCondition,
    } = {
        appliedOrderCondition: {},
        ...appliedView,
    };
    const { appliedOrderType, appliedOrderStatus, appliedNotificationFailure } = appliedFilter;
    
    const [notificationFailureListState, setNotificationFailureList] = useState(notificationFailureList&&notificationFailureList
    );
    const viewportHeight = useViewportHeight();
    
    const toggleCheckedDsktop = useSelector(
        (state) => state.ordersListReducer.toggleCheckedDsktop
    );
    const ToggleChecked = useSelector(
        (state) => state.ordersListReducer.ToggleChecked
    );

    const userFilters = useSelector(
        (state) => state.appliedOrdersFilterReducer
    );
    const deniedOverrideToggleTemp = useSelector(
        (state) => state.ordersListReducer.deniedOverrideToggleTemp
    );

    const { orderStatusCode, orderType, district, territory, account } = filter;

    const updateExpandedFilter = (componentName) => {
        setLocalExpandedFilter({
            ...showLocalExpandedFilter,
            [componentName.view]: componentName.value,
        });
    };

    const updateExpandView = (componentName) => {
        setLocalExpandView({
            ...showLocalExpandView,
            [componentName.view]: componentName.value,
        });
    };
    useEffectWithErrorLogging(() => {
        if (!appliedView?.appliedOrderCondition) {
            dispatch(resetOrderListFilter());
        }
    }, []);
    useEffectWithErrorLogging(() => {
        setInitialFilerHandler();
    }, [showExpandedView, showExpandedFilter]);

    const setInitialFilerHandler = () => {
        if (showExpandedFilter) {
            setLocalExpandedFilter({ ...showExpandedFilter });
        }
        if (showExpandedView) {
            setLocalExpandView({ ...showExpandedView });
        }
       
        if (appliedNotificationFailure && appliedNotificationFailure.length > 0) {
            setNotificationFailureList([...appliedNotificationFailure]);
        } else {
           
            setNotificationFailureList([{ description: 'Notification Failure', isChecked: false, statusCode: 'NOTIFICATION_FAILURE' }]);
        }
    };

    const onToggleTabHandler = (tabName) => {
        switch (tabName) {
            case 'view':
                dispatch(
                    openFilterPopover({
                        isSet: true,
                        isShowView: true,
                        isShowFilter: false,
                    })
                );
                return;
            case 'filter':
                dispatch(
                    openFilterPopover({
                        isSet: true,
                        isShowView: false,
                        isShowFilter: true,
                    })
                );
                return;
        }
    };

    useEffectWithErrorLogging(() => {
        updateFilter();
        setInitialFilerHandler();
        populateOrderType();
        populateOrderStatus();

        dispatch(
            getTerritory({
                districtCode:
                    appliedDistrict?.id !== 'All District'
                        ? appliedDistrict.id
                        : '',
                isOrderListingPage: true,
            })
        );
        dispatch(
            getAccounts({
                district:
                    appliedDistrict?.id &&
                    appliedDistrict?.id !== 'All District'
                        ? appliedDistrict.id
                        : '',
                territory:
                    appliedTerritory?.id &&
                    appliedTerritory?.id !== 'All Territory'
                        ? appliedTerritory.id === 'GSE_T'
                            ? 'GSE'
                            : appliedTerritory.id
                        : '',
                isOrderListingPage: true,
            })
        );
        resumeScrolling();
    }, []);

    useEffectWithErrorLogging(() => {
        updateFilter();
        populateOrderType();
        populateOrderStatus();
    }, [categoryFilters, appliedCategory, appliedQuickFilter]);

    const updateFilter = () => {
        const checkQuickFilterEmpty =
            Object.keys(appliedQuickFilter).length === 0 &&
            appliedQuickFilter.constructor === Object;

        if (!checkQuickFilterEmpty && !appliedQuickFilter.isDefault) {
            setHideFilter(true);
        }

        const checkFilter = checkFilterAvailable();

        if (checkFilter.orderType) {
            setShowOrderType(true);
        }
        if (checkFilter.orderStatus) {
            setShowOrderStatus(true);
        }
    };

    const checkFilterAvailable = () => {
        const isFilterAvailable = { orderType: false, orderStatus: false };

        const checkCategorySelectedEmpty =
            Object.keys(appliedCategory).length === 0 &&
            appliedCategory.constructor === Object;

        const checkQuickFilterEmpty =
            Object.keys(appliedQuickFilter).length === 0 &&
            appliedQuickFilter.constructor === Object;

        if (
            !checkCategorySelectedEmpty &&
            (appliedCategory.categoryName ===
                t('orders.orderListFilterDropDown.all.categoryName') ||
                appliedCategory.categoryName ===
                    t('orders.orderListFilterDropDown.drafts'))
        ) {
            if (
                appliedCategory.categoryName ===
                    t('orders.orderListFilterDropDown.drafts') &&
                appliedQuickFilter.isDefault
            ) {
                isFilterAvailable.orderType = true;
            } else if (
                appliedCategory.categoryName ===
                t('orders.orderListFilterDropDown.all.categoryName')
            ) {
                isFilterAvailable.orderType = true;
            }
        }

        if (
            !checkCategorySelectedEmpty &&
            appliedCategory.categoryName !==
                t('orders.orderListFilterDropDown.drafts')
        ) {
            if (
                appliedCategory.categoryName ===
                    t('orders.orderListFilterDropDown.all.categoryName') &&
                checkQuickFilterEmpty
            ) {
                isFilterAvailable.orderStatus = true;
            } else if (
                appliedCategory.categoryName ===
                t(
                    'orders.orderListFilterDropDown.creditDebitReturns.categoryName'
                )
            ) {
                isFilterAvailable.orderStatus = true;
            } else if (appliedQuickFilter.isDefault) {
                isFilterAvailable.orderStatus = true;
            }
        }

        return isFilterAvailable;
    };
    const populateOrderType = () => {
        const checkFilter = checkFilterAvailable();
        let orderTypeFilters = [];
        if (checkFilter.orderType) {
            const orderTypeList = categoryFilters?.map((x) => x.orderType);

            const allOrderType =
                orderTypeList?.length > 0
                    ? checkFilterOrderType(orderTypeList)
                    : [];
            orderTypeFilters = [...allOrderType];
        }
        setOrderTypeList(orderTypeFilters);
    };

    const checkFilterOrderType = (orderTypeList) => {
        const checkOrderType = ConstantOrderTypeFilter().map((orderFilter) => {
            const orderTypeCode = orderFilter.orderType.filter((x) =>
                orderTypeList.includes(x)
            );
            const selectedOrderTypes =
                orderType !== '' ? orderType?.split(',') : [''];
            const isCheck =
                selectedOrderTypes.length > 0
                    ? orderTypeCode?.some((r) => selectedOrderTypes.includes(r))
                    : false;
            if (orderTypeCode.length > 0) {
                return {
                    statusCode: orderTypeCode.join(','),
                    description: orderFilter.orderTypeName,
                    isChecked: isCheck,
                    isAvailable: orderTypeCode.length > 0,
                };
            }
            return null;
        });

        const selectedOrderType = checkOrderType.filter((x) => x !== null);


        const initOrderType = [
            {
                statusCode: 'ALL_ORDERTYPE',
                description: 'All',
                isChecked:
                    selectedOrderType.filter((x) => x.isChecked).length > 0
                        ? false
                        : true,
            },
        ];
        return orderTypeList?.length && orderTypeList.length > 0
            ? [...initOrderType, ...selectedOrderType]
            : [];
    };

    const populateOrderStatus = () => {
        const checkFilter = checkFilterAvailable();
        let orderStatusFilters = [];
        if (checkFilter.orderStatus) {
            const orderStatus = extractOrderStatus();

            if (orderStatus.length > 0) {
                orderStatusFilters = checkFilterStatus(orderStatus);
            }
        }
        setOrderListStatus(orderStatusFilters);

    };

    const extractOrderStatus = () => {
        const orderTypeValues = appliedCategory.orderType?.split(',');
        const allOrderStatus =
            categoryFilters?.length && categoryFilters.length > 0
                ? appliedCategory.categoryName ===
                  t('orders.orderListFilterDropDown.all.categoryName')
                    ? categoryFilters
                          ?.map((x) => x.orderStatusList)
                          ?.reduce((accumulator, currentValue) => {
                              return [...accumulator, ...(currentValue || [])];
                          }, [])
                    : categoryFilters
                          .map((x) => {
                              if (orderTypeValues.includes(x.orderType)) {
                                  return x.orderStatusList;
                              }
                              return [];
                          })
                          ?.reduce((accumulator, currentValue) => {
                              return [...accumulator, ...(currentValue || [])];
                          }, [])
                : [];
        const orderStatusDescription =
            allOrderStatus?.length && allOrderStatus.length > 0
                ? [...new Set(allOrderStatus.map((x) => x.description))]
                : [];
        const setOrderStatusList =
            orderStatusDescription.length > 0
                ? orderStatusDescription?.map((orderStatus) => {
                      return {
                          description: orderStatus,
                          code: [
                              ...new Set(
                                  allOrderStatus
                                      .filter(
                                          (x) => x.description === orderStatus
                                      )
                                      .reduce((accumulator, currentValue) => {
                                          return [
                                              ...accumulator,
                                              currentValue.code?.split(','),
                                          ];
                                      }, [])
                                      .reduce((accumulator, currentValue) => {
                                          return [
                                              ...accumulator,
                                              ...currentValue,
                                          ];
                                      }, [])
                              ),
                          ].join(','),
                      };
                  })
                : [];
        return setOrderStatusList;
    };

    const checkFilterStatus = (orderStatusList) => {
        const orderStatus = orderStatusList.map((filter) => {
            const filterCode = filter?.code?.split(',');
            const checkedOrderStatus =
                orderStatusCode !== '' ? orderStatusCode?.split(',') : [];

            const isCheck = checkedOrderStatus?.some((r) =>
                filterCode.includes(r)
            );

            return {
                ...filter,
                startDate: convertDateToISOString(
                    new Date(props.firstOrderStartDate),
                    'start'
                ),
                statusCode: filter.code,
                isChecked: isCheck,
            };
        });
        const intiOrderStatus = [
            {
                statusCode: 'ALL_ORDERSTATUS',
                code: 'ALL_ORDERSTATUS',
                description: t('orders.orderDetails.shipAndTrack.all'),
                isChecked:
                    orderStatus.filter((x) => x.isChecked).length > 0
                        ? false
                        : true,
            },
        ];
        return orderStatusList?.length && orderStatusList.length > 0
            ? [...intiOrderStatus, ...orderStatus]
            : [];
    };

    const onCheckBoxChange = (event, filterName) => {
        switch (event.target.name) {
            case 'orderStatusFilters': {
                const orderStatusUpdate = [...orderListStatus];
                const orderStatusIndex = orderStatusUpdate.findIndex(
                    (x) => x.statusCode === event.target.value
                );

                const allOrderStatusIndex = orderStatusUpdate.findIndex(
                    (x) => x.statusCode === 'ALL_ORDERSTATUS'
                );

                if (orderStatusIndex >= 0) {
                    const orderStatus = checkBoxValidate(
                        orderStatusUpdate,
                        event.target.value === 'ALL_ORDERSTATUS' ? true : false,
                        orderStatusIndex,
                        allOrderStatusIndex
                    );
                    setOrderListStatus(orderStatus);
                }
                if (
                    event.target.value == 'ALL_ORDERTYPE' ||
                    (orderStatusUpdate || []).filter((it) => it.isChecked)
                        .length == 0
                ) {
                    const orderStatus = checkBoxValidate(
                        orderStatusUpdate,
                        true,
                        0,
                        allOrderStatusIndex
                    );
                    setOrderListStatus(orderStatus);
                }
                if (
                    event.target.value === 'ALL_ORDERTYPE' ||
                    orderStatusUpdate.splice(1).filter((it) => it.isChecked)
                        .length == 0
                ) {
                    setApply(false);
                } else setApply(true);
                return;
            }
             case 'notificationFailure': {
                                const orderTypeUpdate = [...notificationFailureListState];
                                orderTypeUpdate[0].isChecked = !orderTypeUpdate[0].isChecked;
                                setNotificationFailureList(orderTypeUpdate);
            
                                return;
                        }

            case 'orderTypeFilter': {
                const orderTypeUpdate = [...orderTypeList];
                const orderTypeIndex = orderTypeUpdate.findIndex(
                    (x) => x.statusCode === event.target.value
                );
                const allOrderTypeIndex = orderTypeUpdate.findIndex(
                    (x) => x.statusCode === 'ALL_ORDERTYPE'
                );

                if (orderTypeIndex >= 0) {
                    const orderType = checkBoxValidate(
                        orderTypeUpdate,
                        event.target.value === 'ALL_ORDERTYPE' ? true : false,
                        orderTypeIndex,
                        allOrderTypeIndex
                    );
                    setOrderTypeList(orderType);
                }
                if (
                    event.target.value == 'ALL_ORDERTYPE' ||
                    (orderTypeUpdate || []).filter((it) => it.isChecked)
                        .length == 0
                ) {
                    const orderType = checkBoxValidate(
                        orderTypeUpdate,
                        true,
                        0,
                        allOrderTypeIndex
                    );
                    setOrderTypeList(orderType);
                }
                if (
                    event.target.value === 'ALL_ORDERTYPE' ||
                    orderTypeUpdate.splice(1).filter((it) => it.isChecked)
                        .length == 0
                ) {
                    setApply(false);
                } else setApply(true);

                return;
            }
            default:
                return;
        }
    };

    const checkBoxValidate = (filterList, isAllSelected, index, allIndex) => {
        let filterListUpdate = [];
        if (isAllSelected) {
            filterListUpdate = filterList.map((x, i) => {
                if (i !== index) {
                    x.isChecked = false;
                } else {
                    x.isChecked = true;
                }
                return x;
            });
        } else {
            const filterStatus = filterList[index];
            filterStatus.isChecked = !filterStatus.isChecked;
            filterList[index] = filterStatus;
            filterList[allIndex].isChecked = isAllSelected ? true : false;
            filterListUpdate = [...filterList];
        }
        return filterListUpdate;
    };

    useEffectWithErrorLogging(() => {
        const updateSelectedViews = { ...selectedViews };

        if (appliedDistrict?.id && districtValue.length > 0 && !isViewChange) {
            const updateDistrict = { ...updateSelectedViews.districtView };
            updateDistrict.id = appliedDistrict.id;
            updateDistrict.name = appliedDistrict.name;
            updateSelectedViews.districtView = updateDistrict;
        }
        if (
            appliedTerritory?.id &&
            territoryValue.length > 0 &&
            !isViewChange
        ) {
            const updateTerritory = { ...updateSelectedViews.territoryView };
            updateTerritory.id = appliedTerritory.id;
            updateTerritory.name = appliedTerritory.name;
            updateSelectedViews.territoryView = updateTerritory;
        }
        if (appliedAccount?.id && accountValue.length > 0 && !isViewChange) {
            const updateAccount = { ...updateSelectedViews.accountView };
            updateAccount.id = appliedAccount.id;
            updateAccount.name = appliedAccount.name;
            updateSelectedViews.accountView = updateAccount;
        }
        if (appliedOrderCondition?.id && !isViewChange) {
            const updateOrderCondition = {
                ...updateSelectedViews.orderConditionView,
            };
            updateOrderCondition.id = appliedOrderCondition.id;
            updateOrderCondition.name = appliedOrderCondition.name;
            updateSelectedViews.orderConditionView = updateOrderCondition;
        }

        setSelectedViews(updateSelectedViews);
    }, [districtValue, territoryValue, accountValue]);

    const onFilterChangeHandler = (event, filterName) => {
        setIsViewChange(true);
        const viewUpdate = { ...selectedViews };
        const view = { ...viewUpdate[filterName] };
        view.id = event.id;
        view.name = event.name;
        viewUpdate[filterName] = view;

        if (ORDER_LIST_VIEW_FILTER_DROPDOWN()[0].name === filterName) {
            viewUpdate['territoryView'] = updateDefaultView(
                viewUpdate,
                'territoryView'
            );
            viewUpdate['accountView'] = updateDefaultView(
                viewUpdate,
                'accountView'
            );
        }

        if (ORDER_LIST_VIEW_FILTER_DROPDOWN()[1].name === filterName) {
            viewUpdate['accountView'] = updateDefaultView(
                viewUpdate,
                'accountView'
            );
        }

        setSelectedViews(viewUpdate);
        setApply(true);
        updateViewLists(viewUpdate, filterName);
    };

    const updateDefaultView = (view, type) => {
        switch (type) {
            case 'territoryView': {
                const viewTerritory = { ...view[type] };
                viewTerritory.id = 'All Territory';
                viewTerritory.name = t('orders.orderDetails.shipAndTrack.all');
                return viewTerritory;
            }
            case 'accountView': {
                const viewAccount = { ...view[type] };
                viewAccount.id = 'All Account';
                viewAccount.name = t('orders.orderDetails.shipAndTrack.all');
                return viewAccount;
            }
        }
    };

    const updateViewLists = (viewUpdate, filterName) => {
        dispatch(
            getTerritory({
                districtCode:
                    viewUpdate?.districtView?.id !== 'All District'
                        ? viewUpdate.districtView.id
                        : '',
                isOrderListingPage: true,
            })
        );
        dispatch(
            getAccounts({
                district:
                    viewUpdate?.districtView?.id &&
                    viewUpdate?.districtView?.id !== 'All District'
                        ? viewUpdate.districtView.id
                        : '',
                territory:
                    viewUpdate?.territoryView?.id &&
                    viewUpdate?.territoryView?.id !== 'All Territory'
                        ? viewUpdate.territoryView.id === 'GSE_T'
                            ? 'GSE'
                            : viewUpdate.territoryView.id
                        : '',
                isOrderListingPage: true,
            })
        );
    };

    const handleApplyFilters = () => {
        let orderType = '';
        let orderStatus = '';
        let notificationFailure='';

        const checkCategorySelectedEmpty =
            Object.keys(appliedCategory).length === 0 &&
            appliedCategory.constructor === Object;

        const checkQuickFilterEmpty =
            Object.keys(appliedQuickFilter).length === 0 &&
            appliedQuickFilter.constructor === Object;

        const selectedOrderStatus = checkedOrderStatus(orderListStatus);

        const selectedOrderType = checkedOrderType(orderTypeList);

        const combinedOrderType =
            selectedOrderType?.length > 0 ? selectedOrderType.join(',') : '';

        const combinedOrderStatus =
            selectedOrderStatus?.length > 0
                ? selectedOrderStatus.join(',')
                : '';

        orderType = !checkCategorySelectedEmpty
            ? appliedCategory.categoryName ===
              t('orders.orderListFilterDropDown.all.categoryName')
                ? combinedOrderType
                : appliedCategory.categoryName ===
                  t('orders.orderListFilterDropDown.drafts')
                ? !checkQuickFilterEmpty
                    ? !appliedQuickFilter.isDefault
                        ? appliedQuickFilter.statusCode
                        : combinedOrderType
                    : ''
                : appliedCategory.orderType
            : '';

        orderStatus = !checkQuickFilterEmpty
            ? appliedCategory.categoryName ===
              t('orders.orderListFilterDropDown.drafts')
                ? appliedCategory.orderType
                : appliedQuickFilter.isDefault
                ? combinedOrderStatus
                : appliedQuickFilter?.statusCode &&
                  appliedQuickFilter?.statusCode !== ''
                ? appliedQuickFilter.statusCode
                : ''
            : combinedOrderStatus;

        const checkAwaitingToggleEnable = toggleCheckedDsktop || ToggleChecked;

        let isAwaitingPOEnabled = checkAwaitingToggleEnable;

        handleAppliedFilter(
            orderTypeList,
            orderListStatus,
            notificationFailureListState,
            selectedViews,
            checkAwaitingToggleEnable
        );

        if (
            appliedCategory.categoryName ===
                t('orders.orderListFilterDropDown.all.categoryName') &&
            checkAwaitingToggleEnable
        ) {
            const removePOFilter = orderStatus
                ?.split(',')
                ?.filter((x) => x !== '10013');

            const isOrderTypeSelected = combinedOrderType !== '' ? true : false;

            if (removePOFilter?.length > 0 || isOrderTypeSelected) {
                isAwaitingPOEnabled = false;
                dispatch(awaitingToggle(false));
                dispatch(awaitingToggleMobile(false));
            }
        }

        const checkDistrictEmpty =
            Object.keys(appliedDistrict).length === 0 &&
            appliedDistrict.constructor === Object;
        const checkTerritoryEmpty =
            Object.keys(appliedTerritory).length === 0 &&
            appliedTerritory.constructor === Object;
        const checkAccountEmpty =
            Object.keys(appliedAccount).length === 0 &&
            appliedAccount.constructor === Object;
        const checkOrderConditionEmpty =
            Object.keys(appliedOrderCondition).length === 0 &&
            appliedOrderCondition.constructor === Object;

        const isDistrictVaries = !checkDistrictEmpty
            ? selectedViews?.districtView?.id === appliedDistrict?.id
                ? false
                : true
            : selectedViews?.districtView?.id === 'All District'
            ? false
            : true;

        const isTerritoryVaries = !checkTerritoryEmpty
            ? selectedViews?.territoryView?.id === appliedTerritory?.id
                ? false
                : true
            : selectedViews?.territoryView?.id === 'All Territory'
            ? false
            : true;

        const isAccountVaries = !checkAccountEmpty
            ? selectedViews?.accountView?.id === appliedAccount?.id
                ? false
                : true
            : selectedViews?.accountView?.id === 'All Account'
            ? false
            : true;

        const isOrderConditionVaries = !checkOrderConditionEmpty
            ? selectedViews?.orderConditionView?.id ===
              appliedOrderCondition?.id
                ? false
                : true
            : selectedViews?.orderConditionView?.id === 'Assigned'
            ? false
            : true;

        if (
            isDistrictVaries ||
            isTerritoryVaries ||
            isAccountVaries ||
            isOrderConditionVaries
        ) {
            dispatch(actionApplyFilterType('AppliedView'));
        } else {
            dispatch(actionApplyFilterType('AppliedFilter'));
        }

        dispatch(
            setShowExpandedView({
                ...showLocalExpandView,
            })
        );

        dispatch(
            setShowExpandedFilter({
                ...showLocalExpandedFilter,
            })
        );

        dispatch(
            setOrdersListFilter({
                ...userFilters,
                filter: {
                    ...filter,
                    startDate: convertDateToISOString(
                        new Date(props.firstOrderStartDate),
                        'start'
                    ),
                    orderStatusCode:
                        isDeniedOverrideClicked ||
                        deniedOverrideToggle ||
                        appliedCategory.categoryName ===
                            t(
                                'orders.orderQuickFilters.deniedUsageOverrides.name'
                            )
                            ? '12347,12348'
                            : orderStatus,
                    deniedOverrides:
                        isDeniedOverrideClicked ||
                        deniedOverrideToggle ||
                        appliedCategory.categoryName ===
                            t(
                                'orders.orderQuickFilters.deniedUsageOverrides.name'
                            )
                            ? true
                            : false,
                notificationFailure:notificationFailureListState?.[0]?.isChecked?true:false,
                    orderType:
                        isDeniedOverrideClicked ||
                        deniedOverrideToggle ||
                        appliedCategory.categoryName ===
                            t(
                                'orders.orderQuickFilters.deniedUsageOverrides.name'
                            )
                            ? 'ZLB'
                            : orderType,
                    district:
                        selectedViews?.districtView?.id === 'All District'
                            ? ''
                            : selectedViews.districtView.id,
                    territory:
                        selectedViews?.territoryView?.id === 'All Territory'
                            ? ''
                            : selectedViews.territoryView.id === 'GSE_T'
                            ? 'GSE'
                            : selectedViews.territoryView.id,
                    account:
                        selectedViews?.accountView?.id === 'All Account'
                            ? ''
                            : selectedViews.accountView.id,
                    assignedFlag:
                        selectedViews.orderConditionView.id === 'Assigned'
                            ? true
                            : false,
                },
            })
        );
        //Normal Flow for Non-QuickFilters
        if (
            appliedCategory.categoryName ===
                t('orders.orderListFilterDropDown.all.categoryName') ||
            appliedCategory.categoryName ===
                t(
                    'orders.orderListFilterDropDown.creditDebitReturns.categoryName'
                )
        ) {
            // dispatch(
            //     getRefinedOrderListData({
            //         ...userFilters,
            //         filter: {
            //             ...filter,
            //             orderStatusCode: orderStatus,
            //             orderType: orderType,
            //             district:
            //                 selectedViews?.districtView?.id === 'All District'
            //                     ? ''
            //                     : selectedViews.districtView.id,
            //             territory:
            //                 selectedViews?.territoryView?.id === 'All Territory'
            //                     ? ''
            //                     : selectedViews.territoryView.id,
            //             account:
            //                 selectedViews?.accountView?.id === 'All Account'
            //                     ? ''
            //                     : selectedViews.accountView.id,
            //         },
            //     })
            // );
            //Two Calls Flow
            twoCallApiHandler(false, isAwaitingPOEnabled);
        } else {
            //Two Calls Flow
            twoCallApiHandler(false);
        }
    };

    const twoCallApiHandler = (isResetView, isAwaitingPOEnabled,notificationStatus) => {
        let selectedOrderStatus = checkedOrderStatus(orderListStatus);

        let selectedOrderType = checkedOrderType(orderTypeList);

        if (isResetView) {
            if (
                appliedCategory.categoryName ===
                    t('orders.orderListFilterDropDown.all.categoryName') ||
                appliedCategory.categoryName ===
                    t('orders.orderListFilterDropDown.drafts')
            ) {
                const appliedOrderType = checkAppliedOrderType();
                selectedOrderType = [
                    ...combineResetFilter(selectedOrderType, appliedOrderType),
                ];
            }

            if (
                appliedCategory.categoryName !==
                t('orders.orderListFilterDropDown.drafts')
            ) {
                const appliedOrderStatus = checkAppliedOrderStatus();
                selectedOrderStatus = [
                    ...combineResetFilter(
                        selectedOrderStatus,
                        appliedOrderStatus
                    ),
                ];
            }
        }

        const combinedOrderType =
            selectedOrderType?.length > 0 ? selectedOrderType.join(',') : '';

        const combinedOrderStatus =
            selectedOrderStatus?.length > 0
                ? selectedOrderStatus.join(',')
                : '';
        if (deniedOverrideToggle || deniedOverrideToggleTemp) {
            dispatch(
                getDeniedOrderFilter({
                    ...userFilters,
                    filter: {
                        ...filter,
                        deniedOverrides: true,
                        startDate: convertDateToISOString(
                            new Date(props.firstOrderStartDate),
                            'start'
                        ),
                        orderType: 'ZLB',
                        orderStatusCode: '12347,12348',
                        district: isResetView
                            ? ''
                            : selectedViews?.districtView?.id === 'All District'
                            ? ''
                            : selectedViews.districtView.id,
                        territory: isResetView
                            ? ''
                            : selectedViews?.territoryView?.id ===
                              'All Territory'
                            ? ''
                            : selectedViews.territoryView.id === 'GSE_T'
                            ? 'GSE'
                            : selectedViews.territoryView.id,
                        account: isResetView
                            ? ''
                            : selectedViews?.accountView?.id === 'All Account'
                            ? ''
                            : selectedViews.accountView.id,
                        assignedFlag: isResetView
                            ? true
                            : selectedViews.orderConditionView.id === 'Assigned'
                            ? true
                            : false,
                    },
                })
            );
        }
        dispatch(
            refineFilterAndOrderList(
                {
                    filters: {
                        ...userFilters,
                        filter: {
                            ...filter,
                            startDate: convertDateToISOString(
                                new Date(props.firstOrderStartDate),
                                'start'
                            ),
                            deniedOverrides:
                                isDeniedOverrideClicked ||
                                appliedCategory.categoryName ===
                                    t(
                                        'orders.orderQuickFilters.deniedUsageOverrides.name'
                                    )
                                    ? true
                                    : false,
                            orderType:
                                isDeniedOverrideClicked ||
                                appliedCategory.categoryName ===
                                    t(
                                        'orders.orderQuickFilters.deniedUsageOverrides.name'
                                    )
                                    ? 'ZLB'
                                    : appliedCategory?.categoryName ===
                                      t('orders.orderListFilterDropDown.drafts')
                                    ? ''
                                    : orderType,
                         notificationFailure:notificationFailureListState?.[0]?.isChecked?true:false,
                            orderStatusCode:
                                isDeniedOverrideClicked ||
                                appliedCategory.categoryName ===
                                    t(
                                        'orders.orderQuickFilters.deniedUsageOverrides.name'
                                    )
                                    ? '12347,12348'
                                    : appliedCategory?.categoryName ===
                                      t('orders.orderListFilterDropDown.drafts')
                                    ? appliedCategory.orderType
                                    : '',
                            district: isResetView
                                ? ''
                                : selectedViews?.districtView?.id ===
                                  'All District'
                                ? ''
                                : selectedViews.districtView.id,
                            territory: isResetView
                                ? ''
                                : selectedViews?.territoryView?.id ===
                                  'All Territory'
                                ? ''
                                : selectedViews.territoryView.id === 'GSE_T'
                                ? t(
                                      'orders.orderQuickFilters.deniedUsageOverrides.gse'
                                  )
                                : selectedViews.territoryView.id,
                            account: isResetView
                                ? ''
                                : selectedViews?.accountView?.id ===
                                  'All Account'
                                ? ''
                                : selectedViews.accountView.id,
                            assignedFlag: isResetView
                                ? true
                                : selectedViews.orderConditionView.id ===
                                  'Assigned'
                                ? true
                                : false,
                        },
                        pageLimit: userFilters.pageLimit,
                        pageNo: 0,
                    },
                    appliedQuickFilter: appliedQuickFilter,
                    appliedCategory: appliedCategory,
                    appliedOrderType: combinedOrderType,
                    appliedOrderStatus: combinedOrderStatus,
                    isAwaitingPo: isAwaitingPOEnabled ? true : false,
                    isAwatingPOStatusCode: '10013',
                    isFromOrderHistory: props?.isOrderHistory,
                },
                true,
                deniedOverrideToggle,
                 
            )
        );
 
    };

    const combineResetFilter = (selectedFilter, appliedFilter) => {
        const combineFilter = [...selectedFilter, ...appliedFilter];
        const distinctFilter = [...new Set(combineFilter)];

        return distinctFilter?.length && distinctFilter.length > 0
            ? distinctFilter
            : [];
    };

    const checkAppliedOrderStatus = () => {
        return (
            appliedOrderStatus &&
            appliedOrderStatus
                ?.filter((x) => x.isChecked === true)
                ?.map((a) => {
                    if (a.statusCode === 'ALL_ORDERSTATUS') {
                        return '';
                    }
                    return a.statusCode;
                })
                ?.filter((x) => x !== '')
        );
    };

    const checkAppliedOrderType = () => {
        return (
            appliedOrderType &&
            appliedOrderType
                ?.filter((x) => x.isChecked === true)
                ?.map((a) => {
                    if (a.statusCode === 'ALL_ORDERTYPE') {
                        return '';
                    }
                    return a.statusCode;
                })
                ?.filter((x) => x !== '')
        );
    };

    const checkedOrderStatus = (orderStatus) => {
        return orderStatus
            ?.filter((x) => x.isChecked === true)
            ?.map((a) => {
                if (a.statusCode === 'ALL_ORDERSTATUS') {
                    return '';
                }
                return a.statusCode;
            })
            ?.filter((x) => x !== '');
    };

    const checkedOrderType = (orderType) => {
        return orderType
            ?.filter((x) => x.isChecked === true)
            ?.map((a) => {
                if (a.statusCode === 'ALL_ORDERTYPE') {
                    return '';
                }
                return a.statusCode;
            })
            ?.filter((x) => x !== '');
    };

    const handleAppliedFilter = (
        orderType,
        orderStatus,
        notificationStatus,
        selectedViews,
        isAwaitingToggleEnable
    ) => {
        const selectedOrderType =
            orderType?.length > 0
                ? orderType?.filter((x) => x.isChecked === true)
                : [];
        let selectedOrderStatus =
            orderStatus?.length > 0
                ? orderStatus?.filter((x) => x.isChecked === true)
                : [];

        const isOrderTypeSelected =
            selectedOrderType.filter((x) => x.statusCode !== 'ALL_ORDERTYPE')
                ?.length > 0
                ? true
                : false;

        const removePOOrderStatus =
            isAwaitingToggleEnable &&
            selectedOrderStatus.length === 1 &&
            selectedOrderStatus[0]?.code === '10013' &&
            !isOrderTypeSelected
                ? true
                : false;
        if (removePOOrderStatus) {
            selectedOrderStatus = selectedOrderStatus.filter(
                (x) => x.code !== '10013'
            );
        }

        const view = { ...selectedViews };

        const newAppliedView = {
            appliedDistrict: { ...view.districtView },
            appliedTerritory: { ...view.territoryView },
            appliedAccount: { ...view.accountView },
            appliedOrderCondition: { ...view.orderConditionView }
        };

        const newAppliedFilter = {
            appliedOrderType: [...selectedOrderType],
            appliedOrderStatus: [...selectedOrderStatus],
            appliedNotificationFailure: [notificationStatus?.[0]]
        };

        // Update both appliedFilter (applied state) and notificationFailureList (UI state for persistence)
        dispatch(
            setAppliedFilter({
                appliedView: newAppliedView,
                appliedFilter: newAppliedFilter,
            })
        );
        dispatch(setNotificationFailure([notificationStatus?.[0]]));
    };

    const resetHandler = (filterType) => {
        if (
            filterType === t('orders.orderListFilters.viewLabel') &&
            !resetView
        ) {
            return;
        }

        if (
            filterType === t('orders.orderListFilters.filterLabel') &&
            !resetFilter
        ) {
         
            return;
        }

        switch (filterType) {
            case t('orders.orderListFilters.viewLabel'):
                setSelectedViews({
                    districtView: {
                        id: 'All District',
                        name: t('orders.orderDetails.shipAndTrack.all'),
                    },
                    territoryView: {
                        id: 'All Territory',
                        name: t('orders.orderDetails.shipAndTrack.all'),
                    },
                    accountView: {
                        id: 'All Account',
                        name: t('orders.orderDetails.shipAndTrack.all'),
                    },
                    orderConditionView: {
                        id: 'Assigned',
                        name: t('orders.orderDetails.shipAndTrack.all'),
                    },
                });
                resetAppliedView();
                orderViewReset();
                dispatch(actionApplyFilterType('ResetView'));
                return;
            case t('orders.orderListFilters.filterLabel'): {
                const resetOrderStatus = orderFilterReset(orderListStatus);
                setOrderListStatus(resetOrderStatus);
                const resetOrderType = orderFilterReset(orderTypeList);
                setOrderTypeList(resetOrderType);
                resetAppliedFilter();
                dispatch(actionApplyFilterType('ResetFilter'));
                dispatch(
                    setOrdersListFilter({
                        ...userFilters,
                        filter: {
                            ...filter,
                            startDate: convertDateToISOString(
                                new Date(props.firstOrderStartDate),
                                'start'
                            ),
                            deniedOverrides:
                                isDeniedOverrideClicked ||
                                deniedOverrideToggle ||
                                appliedCategory.categoryName ===
                                    t(
                                        'orders.orderQuickFilters.deniedUsageOverrides.name'
                                    )
                                    ? true
                                    : false,
                            orderType:
                                isDeniedOverrideClicked ||
                                deniedOverrideToggle ||
                                appliedCategory.categoryName ===
                                    t(
                                        'orders.orderQuickFilters.deniedUsageOverrides.name'
                                    )
                                    ? 'ZLB'
                                    : appliedCategory.categoryName ===
                                          t(
                                              'orders.orderListFilterDropDown.all.categoryName'
                                          ) ||
                                      appliedCategory.categoryName ===
                                          t(
                                              'orders.orderListFilterDropDown.drafts'
                                          )
                                    ? ''
                                    : appliedCategory.orderType,
                notificationFailure:notificationFailureListState?.[0]?.isChecked?true:false,

                            orderStatusCode:
                                isDeniedOverrideClicked ||
                                deniedOverrideToggle ||
                                appliedCategory.categoryName ===
                                    t(
                                        'orders.orderQuickFilters.deniedUsageOverrides.name'
                                    )
                                    ? '12347,12348'
                                    : appliedCategory.categoryName ===
                                      t('orders.orderListFilterDropDown.drafts')
                                    ? appliedCategory.orderType
                                    : '',
                        },
                    })
                );
                dispatch(
                    getRefinedOrderListData({
                        ...userFilters,
                        filter: {
                            ...filter,
                            startDate: convertDateToISOString(
                                new Date(props.firstOrderStartDate),
                                'start'
                            ),
                            deniedOverrides:
                                isDeniedOverrideClicked ||
                                deniedOverrideToggle ||
                                appliedCategory.categoryName ===
                                    t(
                                        'orders.orderQuickFilters.deniedUsageOverrides.name'
                                    )
                                    ? true
                                    : false,
                                      notificationFailure:notificationFailureListState?.[0]?.isChecked?true:false,
                            orderType:
                                isDeniedOverrideClicked ||
                                deniedOverrideToggle ||
                                appliedCategory.categoryName ===
                                    t(
                                        'orders.orderQuickFilters.deniedUsageOverrides.name'
                                    )
                                    ? 'ZLB'
                                    : appliedCategory.categoryName ===
                                          t(
                                              'orders.orderListFilterDropDown.all.categoryName'
                                          ) ||
                                      appliedCategory.categoryName ===
                                          t(
                                              'orders.orderListFilterDropDown.drafts'
                                          )
                                    ? ''
                                    : appliedCategory.orderType,
                            orderStatusCode:
                                isDeniedOverrideClicked ||
                                deniedOverrideToggle ||
                                appliedCategory.categoryName ===
                                    t(
                                        'orders.orderQuickFilters.deniedUsageOverrides.name'
                                    )
                                    ? '12347,12348'
                                    : appliedCategory.categoryName ===
                                      t('orders.orderListFilterDropDown.drafts')
                                    ? appliedCategory.orderType
                                    : '',
                        },
                        isFromOrderHistory: props?.isOrderHistory,
                    })
                );
                dispatch(awaitingToggle(false));
                dispatch(awaitingToggleMobile(false));
                return;
            }
        }
    };

    const resetAppliedView = () => {
        const newAppliedView = {
            appliedDistrict: {},
            appliedTerritory: {},
            appliedAccount: {},
            appliedOrderCondition: {}
        };

        dispatch(
            setAppliedFilter({
                appliedView: newAppliedView,
                appliedFilter: { ...appliedFilter },
            })
        );
    };
    const resetAppliedFilter = () => {
        const newAppliedFilter = {
            appliedOrderType: [],
            appliedOrderStatus: [],
            appliedNotificationFailure: []
        };
        
        const orderTypeUpdate = [...notificationFailureListState];
        orderTypeUpdate[0].isChecked = false;
        setNotificationFailureList(orderTypeUpdate);
        dispatch(setNotificationFailure(orderTypeUpdate));
        setApply(false);
        
        dispatch(
            setAppliedFilter({
                appliedView: { ...appliedView },
                appliedFilter: newAppliedFilter,
            })
        );
    };

    const orderViewReset = () => {
        dispatch(
            getTerritory({
                districtCode: '',
                isOrderListingPage: true,
            })
        );
        dispatch(
            getAccounts({
                districtCode: '',
                territory: '',
                isOrderListingPage: true,
            })
        );
        dispatch(
            setOrdersListFilter({
                ...userFilters,
                filter: {
                    ...filter,
                    startDate: convertDateToISOString(
                        new Date(props.firstOrderStartDate),
                        'start'
                    ),
                    account: '',
                    district: '',
                    territory: '',
                    assignedFlag: true,
                },
            })
        );

        if (
            appliedCategory.categoryName ===
                t('orders.orderListFilterDropDown.all.categoryName') ||
            appliedCategory.categoryName ===
                t(
                    'orders.orderListFilterDropDown.creditDebitReturns.categoryName'
                )
        ) {
            // dispatch(
            //     getRefinedOrderListData({
            //         ...userFilters,
            //         filter: {
            //             ...filter,
            //             account: '',
            //             district: '',
            //             territory: '',
            //         },
            //     })
            // );
            const checkAwaitingToggleEnable =
                toggleCheckedDsktop || ToggleChecked;
            twoCallApiHandler(true, checkAwaitingToggleEnable);
        } else {
            twoCallApiHandler(true);
        }
    };

    const orderFilterReset = (filterList) => {
        const resetListStatus = [...filterList];
        const orderStatus = resetListStatus.map((filter) => {
            if (
                filter.statusCode === 'ALL_ORDERSTATUS' ||
                filter.statusCode === 'ALL_ORDERTYPE'
            ) {
                return {
                    ...filter,
                    startDate: convertDateToISOString(
                        new Date(props.firstOrderStartDate),
                        'start'
                    ),
                    isChecked: true,
                };
            }

            return {
                ...filter,
                startDate: convertDateToISOString(
                    new Date(props.firstOrderStartDate),
                    'start'
                ),
                isChecked: false,
            };
        });

        return orderStatus;
    };

    useEffectWithErrorLogging(() => {
        let checkOrderStatusChange = false,
            checkOrderTypeChange = false,
            checkDistrict = false,
            checkTerritory = false,
            checkAccounts = false,
            checkOrderCondition = false,
            notificationFailureStatus=false;

        const orderStatusCodeArray = orderStatusCode?.split(',');

        const orderStatus = orderListStatus.map((element) => {
            const codeSplit =
                element.statusCode === 'ALL_ORDERSTATUS'
                    ? ['']
                    : element?.statusCode?.split(',');
            const condition_one = codeSplit?.some((x) =>
                orderStatusCodeArray?.includes(x)
            );
            const condition_two = element.isChecked;
            if (condition_one !== condition_two) {
                return false;
            }
            return true;
        });

        checkOrderStatusChange = orderStatus?.includes(false);

        const orderTypeCodeArray = orderType?.split(',');

        const orderTypeCheck = orderTypeList.map((element) => {
            const codeSplit =
                element.statusCode === 'ALL_ORDERTYPE'
                    ? ['']
                    : element?.statusCode?.split(',');
            const condition_one = codeSplit?.some((x) =>
                orderTypeCodeArray?.includes(x)
            );
            const condition_two = element.isChecked;
            if (condition_one !== condition_two) {
                return false;
            }
            return true;
        });

        checkOrderTypeChange = orderTypeCheck?.includes(false);

        const checkSeletedView = { ...selectedViews };

        checkDistrict =
            district === ''
                ? checkSeletedView.districtView.id !== 'All District'
                : district !== checkSeletedView.districtView.id;

        checkTerritory =
            territory === ''
                ? checkSeletedView.territoryView.id !== 'All Territory'
                : territory === 'GSE'
                ? 'GSE_T' !== checkSeletedView.territoryView.id
                : territory !== checkSeletedView.territoryView.id;

        checkAccounts =
            account === ''
                ? checkSeletedView.accountView.id !== 'All Account'
                : account !== checkSeletedView.accountView.id;

        checkOrderCondition =
            checkSeletedView.orderConditionView.id !=
            (Object.prototype.hasOwnProperty.call(filter, 'assignedFlag')
                ? filter.assignedFlag
                    ? 'Assigned'
                    : 'Unassigned'
                : 'Assigned');

        // Fix notification failure logic to match orderType/orderStatus pattern
        const notificationFailureCheck = notificationFailureListState.map((element) => {
            const isApplied = appliedNotificationFailure && appliedNotificationFailure.length > 0 
                ? appliedNotificationFailure.some(applied => applied.statusCode === element.statusCode)
                : element.statusCode === 'ALL_ORDERTYPE'; // Default to "All" when nothing is applied
            
            const isCurrentlyChecked = element.isChecked;
            
            if (isApplied !== isCurrentlyChecked) {
                return false;
            }
            return true;
        });
        
        notificationFailureStatus = notificationFailureCheck?.includes(false);

        if (
            checkOrderStatusChange ||
            checkOrderTypeChange ||
            checkDistrict ||
            checkTerritory ||
            checkAccounts ||
            checkOrderCondition||notificationFailureStatus
        ) {
            setApply(true);
        } else {
            setApply(false);
        }

        let checkResetView = false;

        checkResetView =
            checkSeletedView.districtView.id !==
                t('All District') ||
            checkSeletedView.territoryView.id !==
                t('All Territory') ||
            checkSeletedView.accountView.id !==
                t('All Account') ||
            checkSeletedView.orderConditionView.id !== 'Assigned' ||
            district !== '' ||
            territory !== '' ||
            account !== '';
        checkResetView ? setResetView(true) : setResetView(false);

        const checkSelectedOrderStatus =
            orderListStatus.filter((x) => x.statusCode === 'ALL_ORDERSTATUS')
                .length > 0
                ? orderListStatus.filter(
                      (x) => x.statusCode === 'ALL_ORDERSTATUS'
                  )[0]?.isChecked
                : true;
        const checkSelectedOrderType =
            orderTypeList.filter((x) => x.statusCode === 'ALL_ORDERTYPE')
                .length > 0
                ? orderTypeList.filter(
                      (x) => x.statusCode === 'ALL_ORDERTYPE'
                  )[0]?.isChecked
                : true;

        let checkAppliedFilter = false;

        if (
            appliedCategory.categoryName ===
            t('orders.orderListFilterDropDown.all.categoryName')
        ) {
            if (orderStatusCode !== '' || orderType !== '') {
                checkAppliedFilter = true;
            }
        } else if (
            appliedCategory.categoryName ===
            t('orders.orderListFilterDropDown.drafts')
        ) {
            if (orderType !== '') {
                checkAppliedFilter = true;
            }
        } else {
            if (orderStatusCode !== '') {
                checkAppliedFilter = true;
            }
        }
        if (notificationFailureListState?.[0]?.isChecked)
        {
             checkAppliedFilter = true;
        }

        if (
            !checkAppliedFilter &&
            checkSelectedOrderStatus &&
            checkSelectedOrderType
        ) {
            setResetFilter(false);
        } else {
            setResetFilter(true);
        }
    }, [selectedViews, orderTypeList, orderListStatus,notificationFailureListState]);

    const orderStatusHeader =
        appliedCategory.categoryName !==
        t('orders.orderListFilterDropDown.drafts')
            ? ORDER_LIST_FILTER_DROPDOWN()?.find(
                  (x) => x.categoryName === appliedCategory.categoryName
              )?.value
            : '';

    const orderTypeHeader = ORDER_LIST_FILTER_DROPDOWN()[1].value;
     const notificationFailureHeader = ORDER_LIST_FILTER_DROPDOWN()[7].value;
    const checkDefaultSelected = (selectedViewFilter, defaultViewFilter) => {
        if (selectedViewFilter.id === defaultViewFilter.id) {
            return true;
        } else {
            return false;
        }
    };

    return (
        <>
            <FilterBlock>
                <FilterWrapperMain className="FilterWrapperMain" bannerHeight={props.bannerHeight} viewportHeight={viewportHeight}>
                    <FilterHeader>
                        <FilterHeaderContainer>
                            <FilterHeading
                            id="orders-orderlistfilters-view-tab-heading"
                                fontSize={isLanguageChanged && '18px'}
                                onClick={() => onToggleTabHandler('view')}
                                selected={props.showViewPanel}
                                color={isLanguageChanged && '#1010EB'}
                                isRegular={isLanguageChanged}
                            >
                                {t('orders.orderListFilters.viewLabel')}
                            </FilterHeading>
                            {hideFilter ? null : (
                                <FilterHeading
                                id="orders-orderlistfilters-filter-tab-heading"
                                    fontSize={isLanguageChanged && '18px'}
                                    onClick={() => onToggleTabHandler('filter')}
                                    selected={props.showFilterPanel}
                                    color={isLanguageChanged && '#1010EB'}
                                    isRegular={isLanguageChanged}
                                >
                                    {t('orders.orderListFilters.filterLabel')}
                                </FilterHeading>
                            )}
                        </FilterHeaderContainer>

                        <div
                        id="orders-orderlistfilters-reset-button-container"
                            onClick={() => {
                                try {
                                resetHandler(
                                    props.showViewPanel
                                        ? t('orders.orderListFilters.viewLabel')
                                        : t(
                                              'orders.orderListFilters.filterLabel'
                                          )
                                );
                                } catch (error) {
                                    logErrorToConsole(error);
                                }
                            }}
                        >
                            <Reset
                                isView={
                                    props.showViewPanel
                                        ? resetView
                                        : resetFilter
                                }
                            >
                                {props.showViewPanel
                                    ? t('common.resetView')
                                    : t('common.resetFilter')}
                            </Reset>
                        </div>
                    </FilterHeader>
                    <FilterContentMain
                        scrollBarWidth={'7px'}
                        scrollBarBackgroundColor={'#afafaf'}
                        scrollBarBorderRadius={'10px'}
                        scrollbarHeight={'7rem'}
                        scrollBarBackGroundColorOnHover={'#afafaf'}
                        mobileDeviceScrollBarDisplay={'block'}
                        mediumDeviceScrollBarDisplay={'block'}
                    >
                        {props.showViewPanel ? (
                            <>
                                {(props.isOrderHistory
                                    ? ORDER_LIST_VIEW_FILTER_DROPDOWN().filter(v => v.name !== 'orderConditionView')
                                    : ORDER_LIST_VIEW_FILTER_DROPDOWN()
                                )?.map(
                                    (view) => {
                                        return (
                                            <FilterView
                                                key={view.value}
                                                header={view.value}
                                                viewFilterName={view.name}
                                                viewFiltersLists={
                                                    view.value ===
                                                    t(
                                                        'orders.orderListViewFilterDropDown.district'
                                                    )
                                                        ? districtLists
                                                        : view.value ===
                                                          t(
                                                              'orders.orderListViewFilterDropDown.territory'
                                                          )
                                                        ? territoriesLists
                                                        : view.value ===
                                                          t(
                                                              'orders.orderListViewFilterDropDown.account'
                                                          )
                                                        ? accountLists
                                                        : orderConditionLists
                                                }
                                                isExpanded={
                                                    view.value ===
                                                    t(
                                                        'orders.orderListViewFilterDropDown.district'
                                                    )
                                                        ? showLocalExpandView?.districtView
                                                            ? showLocalExpandView.districtView
                                                            : false
                                                        : view.value ===
                                                          t(
                                                              'orders.orderListViewFilterDropDown.territory'
                                                          )
                                                        ? showLocalExpandView?.territoryView
                                                            ? showLocalExpandView.territoryView
                                                            : false
                                                        : view.value ===
                                                          t(
                                                              'orders.orderListViewFilterDropDown.account'
                                                          )
                                                        ? showLocalExpandView?.accountView
                                                            ? showLocalExpandView.accountView
                                                            : false
                                                        : showLocalExpandView?.orderConditionView
                                                        ? showLocalExpandView.orderConditionView
                                                        : false
                                                }
                                                showFavourite={true}
                                                updateExpandedViews={
                                                    updateExpandView
                                                }
                                                selectedViewFilter={
                                                    view.value ===
                                                    t(
                                                        'orders.orderListViewFilterDropDown.district'
                                                    )
                                                        ? selectedViews.districtView
                                                        : view.value ===
                                                          t(
                                                              'orders.orderListViewFilterDropDown.territory'
                                                          )
                                                        ? selectedViews.territoryView
                                                        : view.value ===
                                                          t(
                                                              'orders.orderListViewFilterDropDown.account'
                                                          )
                                                        ? selectedViews.accountView
                                                        : selectedViews.orderConditionView
                                                }
                                                setSelectedViewFilter={
                                                    onFilterChangeHandler
                                                }
                                                isAccountView={
                                                    view.value ===
                                                    t(
                                                        'orders.orderListViewFilterDropDown.account'
                                                    )
                                                        ? true
                                                        : false
                                                }
                                                isShowAppliedView={true}
                                                showDefault={false}
                                                defaultViewFilter={
                                                    view.value ===
                                                    t(
                                                        'orders.orderListViewFilterDropDown.district'
                                                    )
                                                        ? defaultViews.districtView
                                                        : view.value ===
                                                          t(
                                                              'orders.orderListViewFilterDropDown.territory'
                                                          )
                                                        ? defaultViews.territoryView
                                                        : view.value ===
                                                          t(
                                                              'orders.orderListViewFilterDropDown.account'
                                                          )
                                                        ? defaultViews.accountView
                                                        : defaultViews.orderConditionView
                                                }
                                                showDot={
                                                    !checkDefaultSelected(
                                                        view.value ===
                                                            t(
                                                                'orders.orderListViewFilterDropDown.district'
                                                            )
                                                            ? selectedViews.districtView
                                                            : view.value ===
                                                              t(
                                                                  'orders.orderListViewFilterDropDown.territory'
                                                              )
                                                            ? selectedViews.territoryView
                                                            : view.value ===
                                                              t(
                                                                  'orders.orderListViewFilterDropDown.account'
                                                              )
                                                            ? selectedViews.accountView
                                                            : selectedViews.orderConditionView,
                                                        view.value ===
                                                            t(
                                                                'orders.orderListViewFilterDropDown.district'
                                                            )
                                                            ? defaultViews.districtView
                                                            : view.value ===
                                                              t(
                                                                  'orders.orderListViewFilterDropDown.territory'
                                                              )
                                                            ? defaultViews.territoryView
                                                            : view.value ===
                                                              t(
                                                                  'orders.orderListViewFilterDropDown.account'
                                                              )
                                                            ? defaultViews.accountView
                                                            : defaultViews.orderConditionView
                                                    )
                                                }
                                                isFilterDisable={true}
                                            />
                                        );
                                    }
                                )}
                            </>
                        ) : null}
                        {!hideFilter && props.showFilterPanel ? (
                            <>
                                {showOrderType ? (
                                    <CommonFilter
                                        key={orderTypeHeader}
                                        header={orderTypeHeader}
                                        filters={orderTypeList}
                                        onCheckBoxChange={onCheckBoxChange}
                                        isExpanded={
                                            showLocalExpandedFilter?.orderTypeFilter
                                                ? showLocalExpandedFilter.orderTypeFilter
                                                : false
                                        }
                                        updateExpandedViews={
                                            updateExpandedFilter
                                        }
                                        checkBoxName={'orderTypeFilter'}
                                        view={'orderTypeFilter'}
                                        notGroupOrderStatus={true}
                                        isDefault={'ALL_ORDERTYPE'}
                                        isOrderType = {true}
                                    />
                                ) : null}
                                {showOrderStatus && !props.isOrderHistory ? (
                                    <CommonFilter
                                        key={orderStatusHeader}
                                        header={orderStatusHeader}
                                        filters={orderListStatus}
                                        onCheckBoxChange={onCheckBoxChange}
                                        isExpanded={
                                            showLocalExpandedFilter?.OrderStatusView
                                                ? showLocalExpandedFilter.OrderStatusView
                                                : false
                                        }
                                        updateExpandedViews={
                                            updateExpandedFilter
                                        }
                                        notGroupOrderStatus={true}
                                        isDefault={'ALL_ORDERSTATUS'}
                                        fromOrders={true}
                                        isOrderStatus = {true}
                                    />
                                ) : null}
                                 {notificationFailureFilterVisibility===VISIBLE && !props.isOrderHistory ? (
                                    <CommonFilter
                                        key={notificationFailureHeader}
                                        header={notificationFailureHeader}
                                        filters={notificationFailureListState}
                                        onCheckBoxChange={onCheckBoxChange}
                                        isExpanded={
                                            showLocalExpandedFilter?.notificationFailure
                                                ? showLocalExpandedFilter.notificationFailure
                                                : false
                                        }
                                        updateExpandedViews={
                                            updateExpandedFilter
                                        }
                                        checkBoxName={'notificationFailure'}
                                        view={'notificationFailure'}
                                        notGroupOrderStatus={true}
                                        isDefault={'ALL_ORDERTYPE'}
                                         isOrderType = {true}
                                         NoCaseCoversion={true}
                                    />
                                ) : null}
                            </>
                        ) : null}
                        <EmptyBox></EmptyBox>
                        <BottomNavigation
                            justifyContent={'space-evenly'}
                            opacity={'1'}
                            position={'absolute'}
                            padding={'11px'}
                        >
                            <Button
                         id={'orders-orderlist-close-button'}
                          //id={'orders-orderdetails-proceduredata-reportproceduredata'}
                                show={true}
                                //secondary={true}
                                variant={ButtonStyles?.secondary}
                                width={'40%'}
                                height={'38px'}
                                clicked={() => {
                                    try {
                                    props.onClose();
                                    } catch (error) {
                                      logErrorToConsole(error);
                                    }
                                }}
                            >
                                <TextBold color={'#1010EB'}>
                                    {t('orders.orderListFilters.closeButton')}
                                </TextBold>
                            </Button>
                            <Button
                             id="orders-orderlistfilters-apply-button"
                                show={true}
                                // primary={apply ? true : false}
                                 disabled={apply ? false : true}
                                variant={apply ? ButtonStyles?.primary : ButtonStyles?.disabled}
                                width={'40%'}
                                height={'38px'}
                                clicked={() => {
                                    try {
                                        handleApplyFilters();
                                        props.onClose();
                                    } catch (error) {
                                        logErrorToConsole(error);
                                    }
                                }}
                            >
                                <TextBold color={'#FFFF'}>
                                    {t('orders.orderListFilters.applyButton')}
                                </TextBold>
                            </Button>
                        </BottomNavigation>
                    </FilterContentMain>
                </FilterWrapperMain>
            </FilterBlock>
        </>
    );
};

export default OrderListFilters;
